import { exportTypeList } from "./const";

export const exportTypeFormatter = (
  id: string,
): string => {
  const item = exportTypeList.find((type: any) => type.id === id);
  return item ? item.name : "-";
};